import React from "react";
import Featured from "./components/Featured";
import Framed from "./components/Framed";
import Overlay from "./components/Overlay";
import BookActivitiesOverlay from "./components/BookActivitiesOverlay";
import GameOverlay from "./components/GameOverlay";
import RecipiesOverlay from "./components/RecipiesOverlay";
import PostersOverlay from "./components/PostersOverlay";
import BscOverlay from "./components/BscOverlay";
import MoreFunOverlay from "./components/MoreFunOverlay";


const routes = {
  "/": () => null,
  "/videos": () => null,
  "/game/drawdogs": () => <Framed media={'https://draw-dogs.waypastbooks.com/'}/>,
  //"/game/mixed-emotions": () => <Framed media={'https://wpb-mixed-emotions.netlify.app/'}/>,
  "/lesson-plans": () => <Overlay />,
  "/category/book-activities": () => <BookActivitiesOverlay />,
  "/category/games": () => <GameOverlay />,
  "/category/recipes": () => <RecipiesOverlay />,
  "/category/posters": () => <PostersOverlay />,
  "/category/book-song-challenge": () => <BscOverlay />,
  "/bsc/individual": () => (
    <Framed media={'https://form.jotform.com/261095433430148'} 
    visibleCloseButton
    closeButtonColor="#ff50a4"
    backgroundColor="#fda9f8"
   
    >
      <div className="bsc-framed-header">
      <h3 className="framed-header-text">Book Song Challenge 2026: Individual Entry</h3>
      <p className="bsc26-intro-text"><a href="/assets/images/pdf/Individua_Entry_Form_Preview-BookSongChallenge2026.pdf" target="_blank">Click here</a> if you would like to preview the form before you begin your submission.
      </p>
      </div>
    </Framed>
  ),
  "/bsc/teacher-librarian": () => (
    <Framed media={'https://form.jotform.com/261096005805150'}
    visibleCloseButton
    closeButtonColor="#ff50a4"
    backgroundColor="#fda9f8"
    >
      <div className="bsc-framed-header">
        <h3 className="framed-header-text">Book Song Challenge 2026: Teacher/Librarian Entry</h3>
        <p className="bsc26-intro-text"><a href="/assets/images/pdf/Teacher_Librarian_Entry_Form_Preview-BookSongChallenge2026.pdf" target="_blank">Click here</a> if you would like to preview the form before you begin your submission.</p>
      </div>
    </Framed>
  ),
  "/category/more-fun": () => <MoreFunOverlay />,
  "/fun-and-games": () => null,
  "/books": () => null,
  '/video/:id': ({id}) => <Featured media={id}/>,
  '/fun/:id': ({id}) => <Featured media={id}/>
};

export default routes;